/**
 * Store não-reativo da rota que a folha Angular está exibindo no momento.
 *
 * A folha roda um Angular Router próprio (HashLocationStrategy) e navega entre suas
 * rotas via history.pushState, que não emite hashchange/popstate — então o React
 * Router do shell não fica sabendo dessas navegações internas e seu location fica
 * defasado. Este store é a fonte de verdade de "o que a folha exibe agora": o
 * bootstrap da folha o alimenta a cada NavigationEnd, e o AngularLeafHost o consulta
 * ao decidir se precisa remontar a folha numa navegação do shell.
 *
 * É intencionalmente não-reativo (variável de módulo, não estado React): as
 * navegações internas da folha atualizam o valor sem re-renderizar nem remontar o
 * shell — do contrário a folha se remontaria a cada navegação própria, destruindo a
 * tela recém-aberta. A leitura só acontece quando o shell navega e o React já
 * re-renderiza por conta própria.
 */
let displayedPathname: string | null = null;

/**
 * Registra a rota exibida pela folha. Query string e fragmento são descartados para
 * a comparação com o pathname do React Router, que também não os inclui.
 */
export function setLeafDisplayedPath(url: string): void {
  displayedPathname = url.split(/[?#]/)[0];
}

/** Rota atualmente exibida pela folha, ou null quando nenhuma folha está montada. */
export function getLeafDisplayedPath(): string | null {
  return displayedPathname;
}

/** Limpa o valor ao desmontar a folha, evitando decisão de remount com dado obsoleto. */
export function resetLeafDisplayedPath(): void {
  displayedPathname = null;
}
